
const dashboard = {
  // Dashboard
  dashboard: {
    title: "Dashboard",
    subtitle: "Your betting performance overview",
    welcome: "Welcome back!",
    totalPredictions: "Total Predictions",
    winRate: "Win Rate",
    betsWon: "Bets Won: {won} of {total}",
    totalProfit: "Total Profit",
    roiDesc: "ROI: {roi}%",
    activeBets: "Active Bets",
    totalInvested: "Total Invested",
    acrossTickets: "Across {count} tickets",
    totalWinnings: "Total Winnings",
    fromWinning: "From winning tickets",
    recentActivity: "Recent Activity",
    topLeagues: "Top Leagues",
    viewAll: "View All",
    performanceHistory: "Performance History",
    detailedStats: "Detailed Stats",
    monthlyPerformance: "Monthly Performance",
    monthlyPerformanceDesc: "Your win rates and betting volume by month",
    ticketHistory: "Ticket History",
    recentBetting: "Your recent betting activity",
    date: "Date",
    matches: "Matches",
    stake: "Stake",
    odds: "Odds",
    result: "Result",
    status: "Status",
    won: "Won",
    lost: "Lost",
    pending: "Pending",
    cashout: "Cashout",
    prediction: "Prediction",
    potentialWin: "Potential Win",
    betResults: "Bet Results",
    betResultsDesc: "Distribution of winning and losing bets",
    monthlyBets: "Monthly Bets",
    monthlyBetsDesc: "Number of bets placed each month",
    month: "Month",
    numberOfBets: "Number of Bets",
    winRatePercent: "Win Rate %",
    fiftyWinRate: "50% Win Rate",
    betting: "Betting",
    partial: "Partial"
  }
};

export default dashboard;
